import React from "react";
import { CalendarDays, X } from "lucide-react";
import { INK, INK_2, INK_3, LINE, LINE_2, BURGUNDY, BURGUNDY_TINT, BAD_INK, WARN_INK } from "../bureauTokens";

const TONE_COLOR = {
  bad: BAD_INK,
  warn: WARN_INK,
  ok: INK_3,
};

// Simplifié par rapport à la maquette (qui a une vraie grille mensuelle) :
// une liste triée des prochaines échéances suffit pour l'usage réel
// ("qu'est-ce qui arrive bientôt ?") avec beaucoup moins de code à
// maintenir. Couleurs reprises de .mp-ech-* / .cal-pop (mon-poste.css).
function EcheancesCalendarPopover({ items, onClose }) {
  return (
    <>
      <div className="fixed inset-0 z-40" onClick={onClose} />
      <div
        className="absolute right-0 top-12 z-50 w-80 bg-white overflow-hidden"
        style={{ border: `1px solid ${LINE_2}`, borderRadius: 14, boxShadow: "0 18px 48px rgba(20,14,24,.22)" }}
      >
        <div className="flex items-center justify-between px-4 py-3" style={{ borderBottom: `1px solid ${LINE}` }}>
          <div className="flex items-center gap-2 text-xs font-semibold" style={{ color: INK }}>
            <CalendarDays size={14} style={{ color: BURGUNDY }} /> Échéances (3 mois)
          </div>
          <button onClick={onClose} style={{ color: INK_3 }}>
            <X size={15} />
          </button>
        </div>
        <div className="max-h-80 overflow-y-auto py-1.5">
          {items.map((e, i) => (
            <div key={i} className="flex items-center gap-2.5 px-4 py-1.5 text-xs">
              <span className="text-[10.5px]" style={{ color: INK_2, whiteSpace: "nowrap" }}>
                {e.lab}
              </span>
              <span
                className="text-[9px] font-medium uppercase tracking-wide px-1.5 py-0.5 rounded flex-shrink-0"
                style={{ color: BURGUNDY, background: BURGUNDY_TINT }}
              >
                {e.cat}
              </span>
              <span className="flex-1 text-[11px] truncate" style={{ color: INK_2 }}>
                {e.label}
              </span>
              <span
                className="text-[10px] whitespace-nowrap"
                style={{ color: TONE_COLOR[e.tone] || INK_3 }}
              >
                {e.days <= 0 ? "auj." : `J-${e.days}`}
              </span>
            </div>
          ))}
          {items.length === 0 && (
            <div className="text-center text-xs py-6" style={{ color: INK_3 }}>
              Aucune échéance à venir
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default EcheancesCalendarPopover;
